import { Component, Input, OnInit } from '@angular/core';
import { Developer } from 'src/app/shared/models/developer.model';
import { CardModule } from 'primeng/card';
import { NgFor } from '@angular/common';
import { ButtonDirective } from 'primeng/button';

@Component({
  selector: 'app-developer-card',
  templateUrl: './developer-card.component.html',
  styleUrls: ['./developer-card.component.scss'],
  standalone: true,
  imports: [
    CardModule,
    NgFor,
    ButtonDirective,
  ],
})
export class DeveloperCardComponent implements OnInit {
  @Input() developer!: Developer;

  constructor() { }

  ngOnInit(): void { }
}
